/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum SoortVakpositie {
    GEMEENSCHAPPELIJK = "Gemeenschappelijk",
    PROFIELVAK = "Profielvak",
    PROFIELVAK_STER = "Profielvak ster",
    PROFIELMODULE = "Profielmodule",
    SECTORVAK = "Sectorvak",
    KEUZEVAK = "Keuzevak",
    KEUZEVAK_STER = "Keuzevak ster",
    BEROEPSGERICHT_PROGRAMMA = "Beroepsgericht programma",
    BIJLAGE = "Bijlage"
}
